import { resolveUrlChannel } from '@/shared-survey';
import { Channel } from '@/survey-graphql';

export function resolveChannel(rawChannel: string | null | undefined): Channel {
  return resolveUrlChannel(rawChannel) ?? Channel.Link;
}
